const firebaseConfig = {

  apiKey: "AIzaSyAPi57lrB94UrlPRkQA6G2PJL0o0HkUMLI",

  authDomain: "medicare-39cb8.firebaseapp.com",

  projectId: "medicare-39cb8",

  storageBucket: "medicare-39cb8.appspot.com",

  messagingSenderId: "1087509877263",

  appId: "1:1087509877263:web:72684d7b51e8cffed6497a"

};


  export default firebaseConfig;